import { z } from "zod";

// ============================================
// Request Schemas
// ============================================

const loginIdValidation = z
  .string()
  .min(1, "이메일을 입력해주세요")
  .email("올바른 이메일 형식이 아닙니다");

export const nicknameValidation = z
  .string()
  .min(2, "닉네임은 2~6자 사이로 입력해주세요")
  .max(6, "닉네임은 2~6자 사이로 입력해주세요")
  .regex(/^[a-zA-Z가-힣]+$/, "영문 또는 완성된 한글만 입력 가능합니다 (자음/모음 제외)");

export const loginSchema = z.object({
  username: z.string().min(1, "이메일을 입력해주세요").email("올바른 이메일 형식이 아닙니다"),
  password: z.string().min(1, "비밀번호를 입력해주세요"),
});

export const registerSchema = z.object({
  login_id: loginIdValidation,
  password: z
    .string()
    .min(10, "영문+숫자 조합 10자리 이상 입력해주세요")
    .regex(/^(?=.*[a-zA-Z])(?=.*\d)/, "영문과 숫자를 포함해야 합니다"),
  nickname: nicknameValidation,
});

export const loginIdCheckSchema = z.object({
  login_id: loginIdValidation,
});

export const nicknameCheckSchema = z.object({
  nickname: nicknameValidation,
});

export const userUpdateSchema = z.object({
  nickname: nicknameValidation.optional(),
  password: z.string().optional(),
});

export const nicknameUpdateSchema = z.object({
  current_nickname: z.string().min(1, "기존 닉네임을 입력해주세요"),
  new_nickname: nicknameValidation,
});

// ============================================
// Entity Schema (도메인 Entity - 여러 API에서 재사용)
// ============================================

export const userSchema = z.object({
  id: z.number(),
  login_id: z.string(),
  nickname: z.string().nullable().optional(),
  is_active: z.boolean().nullable().optional(),
  created_at: z.string().nullable().optional(),
  updated_at: z.string().nullable().optional(),
});

// ============================================
// Type Exports
// ============================================

export type LoginFormData = z.infer<typeof loginSchema>;
export type RegisterFormData = z.infer<typeof registerSchema>;
export type LoginIdCheckData = z.infer<typeof loginIdCheckSchema>;
export type NicknameCheckData = z.infer<typeof nicknameCheckSchema>;
export type UserUpdateData = z.infer<typeof userUpdateSchema>;
export type NicknameUpdateFormData = z.infer<typeof nicknameUpdateSchema>;

export type User = z.infer<typeof userSchema>;
